var _desc, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Recherche") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "Loupe au-dessus d'une trame de donnees.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  :root{\n    --line:#025D7D;\n    --accent:#30C5E5;\n  }\n  @media (prefers-color-scheme: dark){\n    :root{ --line:#7FD8EE; --accent:#30C5E5; }\n  }\n  .e   {fill:none;stroke:var(--line);stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round}\n  .e2  {fill:none;stroke:var(--line);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.7}\n  .e3  {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.34}\n  .h   {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.22;stroke-dasharray:4 6}\n  .a   {fill:none;stroke:var(--accent);stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round}\n  .a2  {fill:none;stroke:var(--accent);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.75}\n  .face {fill:var(--accent);opacity:.07;stroke:none}\n  .face2{fill:var(--accent);opacity:.16;stroke:none}\n  .faceL{fill:var(--line);opacity:.07;stroke:none}\n  .dot  {fill:var(--accent)}\n  .dotl {fill:var(--line);opacity:.45}\n  .txt  {fill:var(--line);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .txta {fill:var(--accent);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .halo {fill:var(--accent);opacity:.16;transform-box:fill-box;transform-origin:center;\n         animation:pulse 3.4s ease-in-out infinite}\n  .flow {stroke-dasharray:6 10;animation:flow 2.6s linear infinite}\n  .flow2{stroke-dasharray:4 8;animation:flow 3.4s linear infinite reverse}\n  .drift{transform-box:fill-box;transform-origin:center;\n         animation:drift 6s ease-in-out infinite}\n  #scene{animation:float 8s ease-in-out infinite}\n  @keyframes pulse{0%,100%{transform:scale(.62);opacity:.09}50%{transform:scale(1.32);opacity:.34}}\n  @keyframes flow {to{stroke-dashoffset:-32}}\n  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-7px)}}\n  @keyframes drift{0%,100%{transform:translate(0,0)}50%{transform:translate(0,-9px)}}\n  @media (prefers-reduced-motion: reduce){*{animation:none !important}}\n  .d0{animation-delay:0.0s}\n  .d1{animation-delay:0.1s}\n  .d2{animation-delay:0.2s}\n  .d3{animation-delay:0.3s}\n  .d4{animation-delay:0.4s}\n  .d5{animation-delay:0.5s}\n  .d6{animation-delay:0.6s}\n  .d7{animation-delay:0.7s}\n  .d8{animation-delay:0.8s}\n  .d9{animation-delay:0.9s}\n  .d10{animation-delay:1.0s}\n  .d11{animation-delay:1.1s}\n  .d12{animation-delay:1.2s}\n  .d13{animation-delay:1.3s}\n  .d14{animation-delay:1.4s}\n  .d15{animation-delay:1.5s}\n  .d16{animation-delay:1.6s}\n  .d17{animation-delay:1.7s}\n  .d18{animation-delay:1.8s}\n  .d19{animation-delay:1.9s}\n  .d20{animation-delay:2.0s}\n  .d21{animation-delay:2.1s}\n  .d22{animation-delay:2.2s}\n  .d23{animation-delay:2.3s}\n  .d24{animation-delay:2.4s}\n  .d25{animation-delay:2.5s}\n  .d26{animation-delay:2.6s}\n  .d27{animation-delay:2.7s}\n  .d28{animation-delay:2.8s}\n  .d29{animation-delay:2.9s}\n  .d30{animation-delay:3.0s}\n  .d31{animation-delay:3.1s}\n  .d32{animation-delay:3.2s}\n  .d33{animation-delay:3.3s}\n  .d34{animation-delay:3.4s}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scene"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 256 156.6 L 473.2 282 L 256 407.4 L 38.8 282 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 238.9 192.9 L 410.3 291.9 L 273.1 371.1 L 101.7 272.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 238.9 192.9 L 410.3 291.9 L 273.1 371.1 L 101.7 272.1 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 238.9,
    y1: 192.6,
    x2: 101.7,
    y2: 271.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 267.4,
    y1: 209.1,
    x2: 130.3,
    y2: 288.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 296,
    y1: 225.6,
    x2: 158.8,
    y2: 304.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 324.6,
    y1: 242.1,
    x2: 187.4,
    y2: 321.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 353.2,
    y1: 258.6,
    x2: 216,
    y2: 337.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 381.7,
    y1: 275.1,
    x2: 244.6,
    y2: 354.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 410.3,
    y1: 291.6,
    x2: 273.1,
    y2: 370.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 238.9,
    y1: 192.6,
    x2: 410.3,
    y2: 291.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 204.6,
    y1: 212.4,
    x2: 376,
    y2: 311.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 170.3,
    y1: 232.2,
    x2: 341.7,
    y2: 331.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 136,
    y1: 252,
    x2: 307.4,
    y2: 351
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 101.7,
    y1: 271.8,
    x2: 273.1,
    y2: 370.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 261.7 215.7 L 238.9 228.9 L 238.9 245.4 L 261.7 232.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 216 215.7 L 238.9 228.9 L 238.9 245.4 L 216 232.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 238.9 202.5 L 261.7 215.7 L 238.9 228.9 L 216 215.7 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 238.9,
    y1: 219,
    x2: 238.9,
    y2: 202.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 238.9,
    y1: 219,
    x2: 261.7,
    y2: 232.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 238.9,
    y1: 219,
    x2: 216,
    y2: 232.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 238.9 202.5 L 261.7 215.7 L 238.9 228.9 L 216 215.7 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 261.7,
    y1: 215.7,
    x2: 261.7,
    y2: 232.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 238.9,
    y1: 228.9,
    x2: 238.9,
    y2: 245.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 216,
    y1: 215.7,
    x2: 216,
    y2: 232.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 261.7,
    y1: 232.2,
    x2: 238.9,
    y2: 245.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 238.9,
    y1: 245.4,
    x2: 216,
    y2: 232.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 256 271.8 L 233.1 285 L 233.1 301.5 L 256 288.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 210.3 271.8 L 233.1 285 L 233.1 301.5 L 210.3 288.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 233.1 258.6 L 256 271.8 L 233.1 285 L 210.3 271.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 233.1,
    y1: 275.1,
    x2: 233.1,
    y2: 258.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 233.1,
    y1: 275.1,
    x2: 256,
    y2: 288.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 233.1,
    y1: 275.1,
    x2: 210.3,
    y2: 288.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 233.1 258.6 L 256 271.8 L 233.1 285 L 210.3 271.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 256,
    y1: 271.8,
    x2: 256,
    y2: 288.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 233.1,
    y1: 285,
    x2: 233.1,
    y2: 301.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 210.3,
    y1: 271.8,
    x2: 210.3,
    y2: 288.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 256,
    y1: 288.3,
    x2: 233.1,
    y2: 301.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 233.1,
    y1: 301.5,
    x2: 210.3,
    y2: 288.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 341.7 288.3 L 318.9 301.5 L 318.9 318 L 341.7 304.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 296 288.3 L 318.9 301.5 L 318.9 318 L 296 304.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 318.9 275.1 L 341.7 288.3 L 318.9 301.5 L 296 288.3 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 318.9,
    y1: 291.6,
    x2: 318.9,
    y2: 275.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 318.9,
    y1: 291.6,
    x2: 341.7,
    y2: 304.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 318.9,
    y1: 291.6,
    x2: 296,
    y2: 304.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 318.9 275.1 L 341.7 288.3 L 318.9 301.5 L 296 288.3 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 341.7,
    y1: 288.3,
    x2: 341.7,
    y2: 304.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 318.9,
    y1: 301.5,
    x2: 318.9,
    y2: 318
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 296,
    y1: 288.3,
    x2: 296,
    y2: 304.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 341.7,
    y1: 304.8,
    x2: 318.9,
    y2: 318
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 318.9,
    y1: 318,
    x2: 296,
    y2: 304.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "face2",
    cx: 273.1,
    cy: 199.5,
    r: 46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 273.1,
    cy: 199.5,
    r: 46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a2",
    cx: 273.1,
    cy: 199.5,
    r: 36
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M 306.1 232.5 L 339.1 265.5",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 273.1,
    y1: 277.1,
    x2: 273.1,
    y2: 245.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d3",
    cx: 273.1,
    cy: 199.5,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 273.1,
    cy: 199.5,
    r: 3.6
  })), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d0",
    cx: 118,
    cy: 128,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d11",
    cx: 398,
    cy: 150,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d20",
    cx: 424,
    cy: 322,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d6",
    cx: 92,
    cy: 306,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d26",
    cx: 352,
    cy: 96,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d13",
    cx: 128,
    cy: 402,
    r: 2.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.008e6a6f319944edfd8fff36a22ea6d0.svg";
export { ForwardRef as ReactComponent };